/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig(value) {
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'RedirectUriWhitelist': json['RedirectUriWhitelist'] == null ? undefined : json['RedirectUriWhitelist'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'RedirectUriWhitelist': value['RedirectUriWhitelist'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig.js.map